import React from 'react';

import { useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, Text, xcss } from '@atlaskit/primitives';
import { type SearchResultMessagePartial } from '@atlassian/dynamic-cards-search-client';

import { Avatar } from '../../../../../../../../common/ui/avatar';
import { i18n } from './messages';

const threadItemCSS = xcss({
	paddingBottom: 'space.050',
	paddingTop: 'space.050',
});

const nameContainer = xcss({
	whiteSpace: 'nowrap',
});

interface ThreadBodyProps {
	components: {
		Body: React.ComponentType<{ partial: SearchResultMessagePartial }>;
	};
	partial: SearchResultMessagePartial;
}

export const ThreadBody = ({ partial, components }: ThreadBodyProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const linkedEntities = partial?.linkedEntities || [];
	const { Body } = components;

	const threadMessages = [partial, ...linkedEntities].slice(0, 3).map((linkedMessage) => {
		const currentMessageOwnerName =
			linkedMessage?.entity?.createdBy?.thirdPartyUser?.name ||
			formatMessage(i18n.externalPersonLabel);

		return (
			<Box xcss={threadItemCSS}>
				<Inline key={linkedMessage.id} space="space.025" alignBlock="center">
					<Avatar name={currentMessageOwnerName} />
					<Box xcss={nameContainer}>{currentMessageOwnerName}:</Box>
					<Text maxLines={1}>
						<Body partial={linkedMessage} />
					</Text>
				</Inline>
			</Box>
		);
	});

	return <>{threadMessages}</>;
};
